/* eslint-disable no-unused-vars */
import { caseLogicMsg } from '../validationMessages';

function validateBehaviorNodes(caseConf, nodeInfo) {
  const errors = [];

  const hasHelicopter =
    caseConf._startLocation.key === 'HELICOPTER' ||
    (caseConf._endLocation && caseConf._endLocation.key === 'HELICOPTER');

  if (hasHelicopter) {
    // Look at behavior effects to compute if sit and non-sit positions are used
    let isNonSit = false;
    nodeInfo.effectNodes.forEach(node => {
      const { effect } = node.data;
      if (effect && ['ANIMATION_ONE_SHOT', 'ANIMATION_REPEAT'].includes(effect.type)) {
        if (effect.position !== 'SIT') {
          isNonSit = true;
        }
      }
    });
    if (!isNonSit) {
      nodeInfo.effectNodes.forEach(node => {
        const { effect } = node.data;
        if (effect && ['ANIMATION_ONE_SHOT', 'ANIMATION_REPEAT'].includes(effect.type) && effect.position === 'SIT') {
          errors.push(
            caseLogicMsg('Patient cannot only be placed in the seated position when a scene is Helicopter', node.id, { warningId: 'helicopterStance' })
          );
        }
      });
    }
  }

  return {
    errors,
    warnings: [],
  };
}

export default validateBehaviorNodes;